export default __webpack_public_path__ + "static/media/CRA.d94d8288.png";